// extracted by mini-css-extract-plugin
export default {"container":"playerContainer_container__t2JFs","player":"playerContainer_player__nsiis","cell":"playerContainer_cell__JWY8T","text":"playerContainer_text__s67mX"};